'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _sharedSliderJacketCover = require('@bibliocommons/shared-slider-jacket-cover');

var _sharedSliderJacketCover2 = _interopRequireDefault(_sharedSliderJacketCover);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/RecommendationItem.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RecommendationItem = function (_BcReactComponent) {
  _inherits(RecommendationItem, _BcReactComponent);

  function RecommendationItem(props) {
    _classCallCheck(this, RecommendationItem);

    var _this = _possibleConstructorReturn(this, (RecommendationItem.__proto__ || Object.getPrototypeOf(RecommendationItem)).call(this, props));

    _this.bindAll('handleRecommendationClick');
    return _this;
  }

  _createClass(RecommendationItem, [{
    key: 'handleRecommendationClick',
    value: function handleRecommendationClick() {
      this.props.handleClick(this.props.item);
    }
  }, {
    key: 'renderAvailableCount',
    value: function renderAvailableCount() {
      if (this.props.item.availableCopies) {
        return _react2.default.createElement(
          _reactIntl.FormattedMessage,
          { id: 'while_you_wait_available_count', values: { count: this.props.item.availableCopies } },
          function (message) {
            return _react2.default.createElement(
              'span',
              { className: 'available-count' },
              message
            );
          }
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          divProps = _objectWithoutProperties(_props, ['item']);

      delete divProps.handleClick;

      return _react2.default.createElement(
        'div',
        _extends({}, divProps, { className: 'cp-recommendation-item' }),
        _react2.default.createElement(_sharedSliderJacketCover2.default, { key: item.id, item: item, handleClick: this.handleClickRecommendation }),
        this.renderAvailableCount()
      );
    }
  }]);

  return RecommendationItem;
}(_baseBcReactComponent2.default);

exports.default = RecommendationItem;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/recommendation-item/lib/components/RecommendationItem.component.js
// module id = 1458
// module chunks = 1